export default __webpack_public_path__ + "static/media/seth.36f8af95.svg";